import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { fetchCurrentNews } from "../News/newsSlice"
import GoBack from "../subsidiary/GoBack/GoBack"
import Loader from "../subsidiary/Loader/Loader"
import styles from "./CurrentNews.module.css"
import moment from 'moment'
import 'moment/locale/ru'
import Sharing from "../Rating/Sharing";


const CurrentNews = () => {
    const id = useParams().id
    const dispatch = useDispatch()
    const data = useSelector(state => state.newsSlice.currentNews)
    const isLoaded = useSelector(state => state.newsSlice.isLoaded)
    const likes = data?.likes_count
    const sharing = data?.sharings_count
    const isNews = window.location.pathname.split('/')[1] === 'news'
    const date = moment(data.created_at).format('DD MMM YYYY')
    useEffect(() => {
        if (isNews) {
            dispatch(fetchCurrentNews(id))
        }
    }, [id, isNews, dispatch])
    return (
        <>
            {isLoaded && data.media ?
                <div className="content-wrapper">
                    <section className={styles.news + ' main'}>
                        <div className={styles.wrapper}>
                            <GoBack text={date} />
                            <div className={styles.img} style={{
                                background: `${data.media.image ? `linear-gradient(0deg, rgba(0, 0, 0, 0.38), rgba(0, 0, 0, 0.38)), url(${data.media.image})` : 'black'}`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover'
                            }}>
                                <div style={{ padding: '30px' }}>
                                    <h1 className={styles.title}>
                                        {data.name}
                                    </h1>
                                    <div className={styles.tags}>
                                        {data ?
                                            data.tags.map(tag => {
                                                    return <span className={styles.tag}>{tag.name.ru}</span>
                                                }) : ''

                                        }


                                    </div>
                                </div>
                            </div>
                            <div className="content-wrapper">
                                <div className={styles.sharingContainer}>
                                    <Sharing type={'news'} position={'current'}  isLiked={data.is_liked} likes={likes} sharing={sharing} id={id}/>
                                </div>
                                {data.text ? <div dangerouslySetInnerHTML={{ __html: data.text }} className={styles.textContent}>
                                </div> : <div>Текста нет</div>}
                            </div>
                        </div>
                    </section>
                </div> : <Loader />}
        </>
    )
}
export default CurrentNews
